import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from './utils/axios.util';
import {backendUrlV2} from '~/config';
import {TrackChildOutline} from './types/track.types';

export const trackApi = createApi({
  reducerPath: 'trackApi',
  baseQuery: axiosBaseQuery({baseUrl: backendUrlV2}),

  tagTypes: ['TrackData'],

  endpoints: builder => ({
    getTrackChildrenData: builder.query<TrackChildOutline[], number>({
      query: (trackId: number) => ({
        url: `/tracks/${trackId}/children`,
        method: 'GET',
      }),
    }),
  }),
});

export const {useLazyGetTrackChildrenDataQuery} = trackApi;